import script from "./PaymentTypesView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentTypesView.vue?vue&type=script&setup=true&lang=js"

import "./PaymentTypesView.vue?vue&type=style&index=0&id=9a4b5e94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a4b5e94"]])

export default __exports__